module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_3.aca2b29a.png";